<template>
  <v-app id="welcome-wrap">
    <!-- Header -->
    <header-welcome></header-welcome>

    <div class="sections">
      <div class="section-intro">
        <div class="header-title">새로운 기능 및 개선사항</div>
      </div>

      <div class="section">
        <div class="section-title">
          2021년 7월 25일
        </div>
        <div class="section-contents">
          <div class="contents-title">
            개선사항
          </div>
          <div class="contents-text">
            <li class="contents-list-title">프로젝트 화면을 새단장하고, 트리 디자인을 교체했습니다.</li>
            <li class="contents-list-title">프로젝트 도큐먼트 리스트 디자인을 개선했습니다.</li>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          2021년 7월 18일
        </div>
        <div class="section-contents">
          <div class="contents-title">
            개선사항
          </div>
          <div class="contents-text">
            <li class="contents-list-title">랩 화면을 새단장했습니다. 여러 기능에 쉽게 접근할 수 있는 메뉴바가 생겼습니다.</li>
            <li class="contents-list-title">도큐먼트 클립 기능이 추가되었습니다.</li>
            <li class="contents-list-title">프로젝트 로딩 속도를 크게 향상시켰습니다.</li>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          2020년 4월 6일
        </div>
        <div class="section-contents">
          <div class="contents-title">
            새로운 기능
          </div>
          <div class="contents-text">
            <li class="contents-list-title">EndNote나 BibTex 형식의 텍스트 복사 붙여넣기를 통해 도큐먼트를 추가할 수 있습니다.</li>
            <li class="contents-list-title">이제 BibTex 형식으로 도큐먼트를 추가할 수 있습니다!</li>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          2020년 3월 14일
        </div>
        <div class="section-contents">
          <div class="contents-title">
            새로운 기능
          </div>
          <div class="contents-text">
            <li class="contents-list-title">도큐먼트를 복사 붙여넣기를 통해 추가할 수 있습니다.</li>
            <li class="contents-list-title">이제 BibTex 형식으로 도큐먼트를 추가할 수 있습니다. </li>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          2020년 3월 16일
        </div>
        <div class="section-contents">
          <div class="contents-title">
            개선사항
          </div>
          <div class="contents-text">
            <li class="contents-list-title">윈도우 환경에서 노트를 docx로 추출했을 때 한글이 깨지던 현상이 해결되었습니다.</li>
            <li class="contents-list-title">윈도우 환경에서 몇 가지 사용자 환경이 개선되었습니다.</li>
            <li class="contents-list-title">몇 가지 오타가 수정되었습니다.</li>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer-welcome></footer-welcome>
  </v-app>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "Whats-New"
    }
  },
}
</script>

<style scoped>
  .sections {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 20px;
    max-width: 1080px;
    margin: auto;
  }

  .section {
    margin-bottom: 1.5rem;
  }

  .header-title {
    padding: 40px 0;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }

  .section-title {
    padding: 12px 0;
    font-size: 22px;
    font-weight: 700;
  }

  .contents-title {
    padding: 20px 0 7px;
    font-size: 20px;
    font-weight: 700;
  }

  .contents-list-title {
    padding: 7px 0;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/spa/welcome/WhatsNew.vue